import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Breadcrums from "../../../common/breadcrumbs";
import * as blogServices from "../../../services/blog.services";
import sitemapService from '../../../services/sitemap.services';
import { SWAL_SETTINGS, INPUT_LENGTH_500 } from "../../../../../utils/Constants";
import {
    capitalizeFirstLetter,
    globalLoader,
    handleServerValidations,
    validateImageAspectRatio,
} from "../../../../../utils/commonfunction";
import { Tooltip, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import CustomCkeditor from "../../../common/customeditor";
import axios from "axios";

const BlogAdd = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { t } = useTranslation()
    const [submitted, setSubmitted] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [previewimage, setPreviewImage] = useState("");
    const [initialValues, setInitialValues] = useState({
        title: "",
        description: "",
        image: "",
        meta_title: "",
        meta_description: "",
        meta_keyword: "",
    });

    const breadcrumbs = [
        { title: t("admin.faq.link_dashboard"), url: "/admin/dashboard/1" },
        { title: t("Blog"), url: "/admin/cms/blog/list/1" },
        { title: t("admin.faq.link_add"), url: "" },
    ];

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            {/* {dataLoaded ? ( */}
            <Formik
                initialValues={{
                    title: "",
                    meta_title: "",
                    meta_description: "",
                    meta_keyword: "",
                    description: "",
                    image: "",
                }}
                validateOnBlur={false}
                validate={(values) => {
                    const error = {};
                    const MAX_IMAGE_SIZE_MB = 5;
                    const allowedImageTypes = ["image/jpeg", "image/png", "image/webp", "image/gif"];

                    if (!values.title || !values.title.trim()) {
                        error.title = "admin.faq.label_title_error";
                    } else if (values.title.length > INPUT_LENGTH_500) {
                        error.title = "admin.faq.validation_err_reached_maximum_length";
                    }

                    if (!values.meta_title || !values.meta_title.trim()) {
                        error.meta_title = "Meta Title is required";
                    } else if (values.meta_title.length > INPUT_LENGTH_500) {
                        error.meta_title = "admin.faq.validation_err_reached_maximum_length";
                    }

                    if (!values.description || !values.description.trim()) {
                        error.description = "admin.faq.label_description_error";
                    }

                    if (!values.meta_description || !values.meta_description.trim()) error.meta_description = "Meta Description is required";
                    if (!values.meta_keyword || !values.meta_keyword.trim()) error.meta_keyword = "Meta Keyword is required";

                    if (!values.image) {
                        error.image = "Please upload an image.";
                    } else {
                        if (!allowedImageTypes.includes(values.image.type)) {
                            error.image = "Invalid image format. Only JPEG, PNG, WEBP, or GIF allowed.";
                        }
                        const fileSizeMB = values.image.size / (1024 * 1024);
                        if (fileSizeMB > MAX_IMAGE_SIZE_MB) {
                            error.image = `Image size should not exceed ${MAX_IMAGE_SIZE_MB}MB.`;
                        }
                    }

                    return error;
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                    setSubmitted(true);
                    globalLoader(true);
                    console.log(values);
                    let formData = new FormData();
                    formData.append("title", values.title);
                    formData.append("meta_title", values.meta_title);
                    formData.append("meta_description", values.meta_description);
                    formData.append("meta_keyword", values.meta_keyword);
                    formData.append("description", values.description);
                    if (values.image) {
                        formData.append("image", values.image);
                    }
                    blogServices
                        .Add(formData)
                        .then(async (response) => {
                            setSubmitting(false);
                            if (response.success) {
                                Swal.fire({
                                    icon: "success",
                                    text: response.message,
                                    ...SWAL_SETTINGS,
                                });
                                setTimeout(() => {
                                    resetForm({ values: "" });
                                    globalLoader(false);
                                    navigate(`/admin/cms/blog/list/1`);
                                }, 1000);
                                try {
                                    await sitemapService.generateSitemap(); // This will internally use the base URL from the .env file
                                    console.log("Sitemap generated successfully");
                                } catch (error) {
                                    console.error("Error generating sitemap:", error);
                                }
                                // await axios.get('http://localhost:3000/api/generate-sitemap').then((response) => {
                                //     console.log("Sitemap generated successfully");
                                // }).catch((error) => {
                                //     console.error("Error generating sitemap:", error);
                                // });
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    text: handleServerValidations(response),
                                    ...SWAL_SETTINGS,
                                });
                                setSubmitted(false);
                                globalLoader(false);
                            }
                        })
                        .catch((error) => {
                            console.log("error ====> ", error);
                        });
                }}
            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched, isSubmitting }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="row row-sm">
                            <div className="col-lg-12 col-md-12 animation_fade">
                                <div className="card custom-card">
                                    <div className="card-body">
                                        <div>
                                            <h6 className="main-content-label mb-3">{t("Add Blog")}</h6>
                                        </div>
                                        <div className="row row-sm">
                                            <div className="col-lg-6 text-center form-group">
                                                <label htmlFor="title" className="text-left d-flex">
                                                    {t("admin.faq.list_heading_title")}:<span className="requirestar">*</span>
                                                </label>
                                                <input
                                                    name="title"
                                                    id="title"
                                                    type="text"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.title}
                                                    className="form-control"
                                                    placeholder={t("Enter title")}
                                                />
                                                <span className="text-danger d-flex text-left">{errors.title && touched.title && t(errors.title)}</span>
                                            </div>

                                            <div className="col-lg-6 text-center form-group">
                                                <label htmlFor="meta_title" className="text-left d-flex">
                                                    {t("Meta Title")}:<span className="requirestar">*</span>
                                                </label>
                                                <input
                                                    name="meta_title"
                                                    id="meta_title"
                                                    type="text"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.meta_title}
                                                    className="form-control"
                                                    placeholder={t("Enter meta title")}
                                                />
                                                <span className="text-danger d-flex text-left">{errors.meta_title && touched.meta_title && t(errors.meta_title)}</span>
                                            </div>  

                                            <div className="col-lg-12 text-center form-group required">
                                                <label htmlFor="meta_description" className="text-left d-flex">
                                                    {t("Meta Description")}: <span className="requirestar">*</span>{" "}
                                                </label>
                                                <textarea
                                                    name="meta_description"
                                                    id="meta_description"
                                                    rows="2"
                                                    type="text"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.meta_description}
                                                    className="form-control"
                                                />
                                                <span className="text-danger d-flex text-left">{errors.meta_description}</span>
                                            </div>

                                            <div className="col-lg-12 text-center form-group required">
                                                <label htmlFor="meta_keyword" className="text-left d-flex">
                                                    {t("Meta Keywords")}: <span className="requirestar">*</span>{" "}
                                                </label>
                                                <textarea
                                                    name="meta_keyword"
                                                    id="meta_keyword"
                                                    rows="2"
                                                    type="text"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.meta_keyword}
                                                    className="form-control"
                                                />
                                                <span className="text-danger d-flex text-left">{errors.meta_keyword}</span>
                                            </div>

                                            <div className="col-lg-12 text-center form-group">
                                                <label htmlFor="description" className="text-left d-flex">
                                                    {t("admin.faq.label_description")}:<span className="requirestar">*</span>
                                                </label>
                                                <CustomCkeditor fieldname={"description"} setFieldValue={setFieldValue} value={values.description} setFieldTouched={setFieldTouched} />
                                                <span className="text-danger d-flex text-left">{errors.description && touched.description && t(errors.description)}</span>
                                            </div>
                                            <div className="col-lg-12 text-center form-group">
                                                <label htmlFor="image" className="text-left d-flex">
                                                    Upload Image:
                                                    <small className="text-muted d-block mt-1 ms-2">
                                                        Please upload an image in{" "}
                                                        <strong>
                                                            {3}:{2} ratio
                                                        </strong>
                                                        (e.g.,{" "}
                                                        <code>
                                                            {3 * 300}px width × {2 * 300}px height
                                                        </code>
                                                        ).
                                                    </small>
                                                </label>
                                                <input
                                                    className="form-control imgInput"
                                                    id="image"
                                                    name="image"
                                                    accept="image/*"
                                                    type="file"
                                                    // onChange={(event) => {
                                                    //     setFieldValue("image", event.target.files[0] || "");
                                                    //     event.target.files.length === 1 ? setPreviewImage(URL.createObjectURL(event.target.files[0])) : setPreviewImage("");
                                                    // }}
                                                    // onChange={(event) => {
                                                    //     const file = event.target.files[0];
                                                    //     if (!file) return;

                                                    //     const reader = new FileReader();
                                                    //     reader.onload = function (e) {
                                                    //         const img = new Image();
                                                    //         img.onload = function () {
                                                    //             const width = img.width;
                                                    //             const height = img.height;
                                                    //             const aspectRatio = width / height;
                                                    //             const expectedRatio = 3 / 2;

                                                    //             // Allow a small margin of error (e.g., ±0.05)
                                                    //             if (Math.abs(aspectRatio - expectedRatio) > 0.05) {
                                                    //                 Swal.fire({
                                                    //                     icon: "error",
                                                    //                     text: `Invalid aspect ratio. Expected ${3}:${2} (e.g., ${3 * 300}px × ${2 * 300}px).`,
                                                    //                     ...SWAL_SETTINGS,
                                                    //                 });
                                                    //                 setFieldValue("image", null);
                                                    //                 setPreviewImage("");
                                                    //                 document.getElementById("image").value = "";
                                                    //             } else {
                                                    //                 setFieldValue("image", file);
                                                    //                 setPreviewImage(URL.createObjectURL(file));
                                                    //             }
                                                    //         };
                                                    //         img.src = e.target.result;
                                                    //     };
                                                    //     reader.readAsDataURL(file);
                                                    // }}
                                                    onChange={async (event) => {
                                                        const file = event.target.files[0];
                                                        if (!file) return;

                                                        try {
                                                            const previewURL = await validateImageAspectRatio(file, 3, 2); // for 3:2 aspect ratio
                                                            setFieldValue("image", file);
                                                            setPreviewImage(previewURL);
                                                        } catch (errorMessage) {
                                                            Swal.fire({
                                                                icon: "error",
                                                                text: errorMessage,
                                                                ...SWAL_SETTINGS,
                                                            });
                                                            setFieldValue("image", null);
                                                            setPreviewImage("");
                                                            document.getElementById("image").value = "";
                                                        }
                                                    }}
                                                />
                                                {previewimage ? (
                                                    <ul className="question-image-preview questions-ul">
                                                        <li className="pr_img_box">
                                                            <img src={previewimage} style={{ height: "100px" }} alt={"Blog-image"} />
                                                            <div className="img_options">
                                                                <button
                                                                    type="button"
                                                                    className="text-danger"
                                                                    onClick={() => {
                                                                        setPreviewImage("");
                                                                        setFieldValue("image", null);
                                                                        document.getElementById("image").value = "";
                                                                    }}
                                                                >
                                                                    <i className="ri-delete-bin-6-fill"></i>
                                                                </button>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                            <div className="">
                                                <button className="btn btn-main-primary signbtn mr-2" type="submit" disabled={submitted ? true : null}>
                                                    <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                    {t("admin.button.btn_submit")}
                                                </button>
                                                <button className="btn ripple btn-secondary" type="button" disabled={submitted ? true : null} onClick={() => navigate(-1)}>
                                                    <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                                                    {t("admin.button.btn_cancel")}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                )}
            </Formik>
            {/* ) : (
                <></>
            )} */}
        </>
    );
};

export default BlogAdd;
